/**
 * ConfirmationModal default copy — used only when a caller omits
 * the title / message / confirmText / cancelText prop. Every real
 * call site should pass its own explicit (already-localized) strings;
 * this is the fallback layer.
 *
 * Re-export shim over /locales/{en,ht,fr,es}.json (confirmation_modal key).
 */
import en from '../locales-shared/en.json'
import ht from '../locales-shared/ht.json'
import fr from '../locales-shared/fr.json'
import es from '../locales-shared/es.json'
import ptBR from '../locales-shared/pt-BR.json'
import zhHans from '../locales-shared/zh-Hans.json'

const COPY = {
  en: en.confirmation_modal,
  ht: ht.confirmation_modal,
  fr: fr.confirmation_modal,
  es: es.confirmation_modal,
  'pt-BR': ptBR.confirmation_modal,
  'zh-Hans': zhHans.confirmation_modal,
}

export default COPY
